import { Col, Row } from "react-bootstrap";
import styles from './ModalBox.module.css'
import { JSX } from "react";

type ModalProps = {
    title: string
    children: JSX.Element
}

export default function ModalBox({title, children}: ModalProps) {
    return(
        <div className={`${styles.modalBoxContainer}`}>
            <Row className={`${styles.modalBoxTitleRow} m-0 p-0`}>
                <Col className={`${styles.modalBoxTitle} col-12`}>
                   {title}
                </Col>

                <Col className={`${styles.modalBoxLine} col-12`} />
            </Row>
            
             <Row className={`col-12 m-0 p-0 pt-2`}>
                <Col>
                    {children}
                </Col>
            </Row>
        </div>
    )
}